"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forwardTracingHeaders = exports.HeaderKeys = void 0;
const cross_fetch_1 = require("cross-fetch");
const uuid_1 = require("uuid");
var HeaderKeys;
(function (HeaderKeys) {
    HeaderKeys["requestId"] = "X-Request-ID";
    HeaderKeys["correlationId"] = "X-Correlation-ID";
})(HeaderKeys = exports.HeaderKeys || (exports.HeaderKeys = {}));
const forwardTracingHeaders = (ctx, next) => {
    // AWS X-Ray is tracked automatically when enabled in app (by default in lambda),
    // to do so use `aws-xray-sdk` in your service, it is out of scope of this lib
    var _a, _b;
    const incomingHeaders = new cross_fetch_1.Headers(ctx.options.incomingHeaders);
    const requestId = (_a = incomingHeaders === null || incomingHeaders === void 0 ? void 0 : incomingHeaders.get(HeaderKeys.requestId)) !== null && _a !== void 0 ? _a : (0, uuid_1.v4)();
    const correlationId = (_b = incomingHeaders === null || incomingHeaders === void 0 ? void 0 : incomingHeaders.get(HeaderKeys.correlationId)) !== null && _b !== void 0 ? _b : (0, uuid_1.v4)();
    ctx.options.headers = new cross_fetch_1.Headers(ctx.options.headers);
    ctx.options.headers.set(HeaderKeys.requestId, requestId);
    ctx.options.headers.set(HeaderKeys.correlationId, correlationId);
    return next();
};
exports.forwardTracingHeaders = forwardTracingHeaders;
//# sourceMappingURL=forwardTracingHeaders.js.map